var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "confirm-create-container",
      attrs: { "hide-overlay": true },
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn--orange",
          attrs: { slot: "activator", type: "button", id: "create_tender" },
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
          slot: "activator",
        },
        [_vm._v(_vm._s(_vm.$t("action.newTender")))]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: {
            showCloseBtn: false,
            modalId: "confirm-create-" + +new Date(),
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-container",
              attrs: { id: "confirm-create-container" },
            },
            [
              _c("p", { staticClass: "confirm-header" }, [
                _vm._v(_vm._s(_vm.$t("hint.draftType"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "msg_hint" }, [_vm._v("Choose a Type")]),
              _vm._v(" "),
              _c("HKLSelect", {
                attrs: {
                  value: _vm.draftType || undefined,
                  options: _vm.draftTypeHklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: {
                  change: function ($event) {
                    _vm.draftType = $event || ""
                  },
                },
              }),
              _vm._v(" "),
              _vm.hint
                ? _c(
                    "span",
                    {
                      staticClass: "alert alert--error",
                      attrs: { id: "hint" },
                    },
                    [_vm._v(_vm._s(_vm.hint))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.goCreate(_vm.draftType)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.enter")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }